export default __webpack_public_path__ + "static/media/img (2).a32a5587.jpg";